import { Directive, forwardRef, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[mustHaveLowercase]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MustHaveLowercaseDirective),
            multi: true,
        },
    ],
    standalone: false
})
export class MustHaveLowercaseDirective {
  @Input('mustHaveLowercase') validationNeeded: boolean;

  validator: Function;

  constructor() {
    this.validator = validateLowercase;
  }

  validate(control: UntypedFormControl) {
    return this.validationNeeded ? this.validator(control) : null;
  }
}

export function validateLowercase(control: UntypedFormControl) {
  let LOWERCASE_REGEX = new RegExp(/[a-z]/);

  return LOWERCASE_REGEX.test(control.value)
    ? null
    : {
        mustHaveLowercase: true,
      };
}
